Ext.define('SA.AcsTable.Toolbar', {
    alias: 'widget.acs-table-toolbar',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-acs-toolbar',

    items: [
        {
            xtype: 'pvt-text',
            cls: 'sa-acs-toolbar-table-search-field-label',
            text: 'Table:'
        }, {
            xtype: 'acs-table-search-field',
            itemId: 'tableSearchField',
            disabled: true
        }, {
            xtype: 'pvt-text',
            cls: 'sa-acs-toolbar-edition-dropdown-label',
            text: 'Edition:'
        }, {
            xtype: 'combo-button',
            itemId: 'editionDropdown',
            textField: 'text',
            ui: 'underline',
            valueField: 'value',
            disabled: true
        }, {
            xtype: 'pvt-fill'
        }, {
            xtype: 'sa-menu-button',
            itemId: 'viewActionsBtn',
            text: 'View Actions',

            menu: {
                xtype: 'menu',

                items: [
                    {text: 'Edit View', itemId: 'editViewMenuItem'},
                    {xtype: 'menuseparator'},
                    {text: 'Delete View', itemId: 'deleteViewMenuItem'}
                ]
            }
        }, {
            xtype: 'sa-button',
            cls: 'sa-acs-toolbar-export-btn',
            disabled: true,
            icon: 'sa-icon-export',
            text: 'Export'
        }
    ],

    setLoaded() {
        this.down('#tableSearchField').enable();
        this.down('#editionDropdown').enable();
    },

    setLoading() {
        this.down('#tableSearchField').disable();
        this.down('#editionDropdown').disable();
    }
});